
import React from "react";
import { RegulationItem } from "../RegulationItem";
import { Flame } from "lucide-react";

export const CampfireSafety = () => {
  return (
    <RegulationItem 
      value="campfire-safety" 
      icon={Flame}
      iconColor="text-orange-500"
      title="Campfire Safety"
    >
      <ul className="space-y-2 text-tribal-neutral list-disc pl-5">
        <li>Never leave fires unattended. Fully extinguish when not supervised.</li>
        <li>Observe local Fire Department burn bans and restrictions.</li>
        <li>Fires must be built only within designated fire rings or grills.</li>
      </ul>
    </RegulationItem>
  );
};
